const _ = require('underscore/underscore-min');
const Utils = require('core-helpers/utils.js');
const ExceptionService = require('exceptions/exception-service.js');
const PurchaseService = require('purchase/purchase-service.js');

(function(root, doc, undefined) {

    // Private vars
    const filename = 'discount-banner.js';
    const hiddenClass = 'discount-banner--hidden';
    let discountBanner = null;
    let discountBannerText = null;

    const getTranslation = (key) => {
        return BUSUU_TRANSLATIONS[key] || 'Trs Not Found';
    };

    const showDiscountBanner = () => {
        Utils.removeClass(discountBanner, hiddenClass);
    };

    const getHeaderDiscountString = (discountAmount) => {
        let discountString = getTranslation('PERCENT_OFF_PREMIUM');
        return discountString.replace('%s', discountAmount);
    };

    // Inject the discount string into the component markup
    const appendDiscountAmount = (data) => {
        const headerDiscountBannerString = getHeaderDiscountString(data.discountPercentage);
        if(headerDiscountBannerString) {
            Utils.setText(discountBannerText, headerDiscountBannerString);
            showDiscountBanner();
        }
    };

    /**
     * On API call succes, we want to do 2 things:
     * - Filter the plans to keep the cheapest
     * - Append the correct string to the banner
     * @param {Object} API response
     */
    const onSuccess = (data) => {
        const cheapestPlan = PurchaseService.getCheapestPlan(data.plans);
        if(cheapestPlan && cheapestPlan.hasOwnProperty('discountPercentage')){
            appendDiscountAmount(cheapestPlan);
        }
    };

    // Get available plans
    const fetchPlans = () => {
        PurchaseService.getPlans().then(onSuccess).done();
    };

    // Only init if banner markup is found in DOM
    const init = () => {
        discountBanner = Utils.getById('discount-banner');
        discountBannerText = Utils.getById('discount-banner-text');
        if(discountBanner && discountBannerText) {
            fetchPlans();
        }
    };

    init();

}(window, document));
